var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "send_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m374.77,217.14s.01-.09.02-.14c.04-.39.06-.77.06-1.17,0-.42-.02-.83-.06-1.24,0-.06-.02-.12-.02-.18-.04-.34-.09-.68-.16-1.01-.01-.06-.03-.12-.04-.18-.07-.35-.16-.69-.27-1.03,0-.02-.01-.04-.02-.07-.46-1.47-1.18-2.84-2.13-4.02l.52-1.28-4.92-2.15c-.13-.06-.26-.12-.39-.17,0,0-.02,0-.03-.01-.02-.01-.05-.02-.07-.03L72.82,75.55c-1.47-.59-3.01-.89-4.6-.89-3.39,0-6.66,1.42-8.97,3.9-3.49,3.74-4.31,9.13-2.08,13.74l59.8,123.44-60.55,121.86c-2.25,4.53-1.46,10.07,1.96,13.78,2.32,2.52,5.61,3.96,9.04,3.96,1.56,0,3.08-.29,4.53-.87l295.25-127.3s.08-.04.12-.05c.03-.01.07-.03.1-.04.33-.14.65-.3.97-.47l.07-.04c3.19-1.74,5.42-4.76,6.14-8.28,0-.02,0-.04.01-.06.07-.36.13-.72.17-1.09Zm-70.63-13.62h-165.79s-44.87-92.61-44.87-92.61l210.66,92.61Zm-165.88,24.56h165.06s-210.3,91.06-210.3,91.06l45.24-91.06Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.f786d8864e44e073dc36f170077437b7.svg";
export { ForwardRef as ReactComponent };